import { render, staticRenderFns } from "./Agentes.vue?vue&type=template&id=a1b9c17c&"
import script from "./Agentes.js?vue&type=script&lang=js&"
export * from "./Agentes.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports